import React from "react";
import WashingtonDC from "../../assets/washington.jpg";
import NewYork from "../../assets/newyork.jpg";
import Milwaukee from "../../assets/milwaukee.jpg";
import { ArrowRightLeft } from "lucide-react";

const popularRoutesData = [
  {
    from: "New York",
    to: "Washington DC",
    time: "3h 20m",
    fare: "from $31",
    image: WashingtonDC,
  },
  {
    from: "Boston",
    to: "New York",
    time: "4h 05m",
    fare: "from $28",
    image: NewYork,
  },
  {
    from: "Chicago",
    to: "Milwaukee",
    time: "1h 29m",
    fare: "from $19",
    image: Milwaukee,
  },
];

export default function PopularRoutes() {
  return (
    <section className="mx-auto mt-16 max-w-7xl px-4 pb-16 sm:mt-24 sm:px-6 sm:pb-24 lg:px-8">
      <div className="mb-8 flex flex-col justify-between gap-4 sm:mb-10 md:flex-row md:items-end">
        <div>
          <span className="mb-2 block text-xs font-bold uppercase tracking-widest text-indigo-600 sm:text-sm">
            Curated Journeys
          </span>
          <h2 className="text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            Popular Destinations
          </h2>
        </div>
        <button className="text-left text-xs font-bold text-indigo-600 hover:text-indigo-800 md:text-right sm:text-sm">
          View All Routes &rarr;
        </button>
      </div>

      <div className="grid gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3">
        {popularRoutesData.map((route, idx) => (
          <div
            key={idx}
            className="group relative overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm transition-all hover:shadow-xl hover:shadow-slate-900/10 cursor-pointer"
          >
            {/* Background Image with Hover Zoom */}
            <div className="aspect-[4/3] w-full overflow-hidden bg-slate-200">
              <img
                src={route.image}
                alt={`Train route to ${route.to}`}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
            </div>

            {/* Gradient Overlay for Text Readability */}
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-950/20 to-transparent pointer-events-none" />

            {/* Content Details */}
            <div className="absolute bottom-0 w-full p-5 text-white sm:p-6 pointer-events-none">
              <div className="mb-1 flex items-center gap-2 opacity-90 sm:mb-2">
                <span className="text-xs font-medium sm:text-sm">
                  {route.from}
                </span>
                <ArrowRightLeft className="h-3 w-3" />
                <span className="text-xs font-medium sm:text-sm">
                  {route.to}
                </span>
              </div>

              <div className="flex items-end justify-between">
                <h3 className="text-xl font-bold sm:text-2xl">{route.to}</h3>
                <div className="text-right">
                  <span className="block text-[10px] font-medium text-slate-300 sm:text-xs">
                    Starting at
                  </span>
                  <span className="text-base font-bold text-emerald-400 sm:text-lg">
                    {route.fare}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
